var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content animate-panel",attrs:{"id":"content"}},[_c('h2',{staticClass:"m-n"},[_vm._v("プレミアム")]),_vm._v(" "),_c('div',{staticClass:"hpanel"},[_c('nav-tabs',{attrs:{"data":_vm.data,"currentTab":_vm.tab}}),_vm._v(" "),_c('tab-content',{attrs:{"data":_vm.data,"currentTab":_vm.tab}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59c411c1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/premium/Premium.vue
// module id = null
// module chunks = 